import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '@/../tailwind.config';

export const themeRawValues = resolveConfig(tailwindConfig).theme;

export const cardFullWidth = 'col-span-12 h-full min-h-full';
export const cardOneHalf = 'col-span-12 lg:col-span-6 h-full min-h-full';
export const cardOneThird = 'col-span-12 xl:col-span-6 2xl:col-span-5 h-full min-h-full';
export const cardTwoThirds = 'col-span-12 xl:col-span-6 2xl:col-span-7 h-full min-h-full';
export const cardOneFourth = 'col-span-6 xl:col-span-3 2xl:col-span-3 h-full min-h-full';
